import { jsxs as d, jsx as f } from "react/jsx-runtime";
import { FormikContext as j } from "formik";
import { forwardRef as y, useState as S, useContext as D, useCallback as E, useEffect as L } from "react";
import { useMultiStyleConfig as M, useCheckbox as R, chakra as o } from "@chakra-ui/react";
import { getCheckboxIcon as q } from "./Checkbox.utils.es.js";
const J = y(
  ({
    children: l,
    defaultChecked: n = !1,
    isChecked: r,
    labelPosition: p,
    leftIcon: m,
    name: i,
    onChange: s,
    rightIcon: u,
    trackId: x,
    variant: b = "default",
    sx: C,
    ...v
  }, _) => {
    const [I, a] = S(n || r), t = M("CheckboxTheme", { variant: b }), c = D(j), h = c && i ? c == null ? void 0 : c.getFieldProps(i) : {}, P = E(
      (k) => {
        s == null || s(k.currentTarget.checked), a(k.currentTarget.checked);
      },
      [s]
    );
    L(() => {
      r !== void 0 && a(r);
    }, [r]);
    const { state: e, getCheckboxProps: g, getInputProps: w, getLabelProps: F, htmlProps: T } = R({
      ...v,
      onChange: P,
      defaultChecked: n || h.value,
      isChecked: I
    });
    return /* @__PURE__ */ d(
      o.label,
      {
        ref: _,
        __css: {
          flexDirection: p === "left" ? "row-reverse" : "row",
          ...t.container,
          ...C
        },
        ...T,
        ...h,
        "track-id": x,
        children: [
          /* @__PURE__ */ d(o.div, { __css: t.controlContainer, children: [
            /* @__PURE__ */ f("input", { ...w(), checked: e.isChecked, name: i }),
            /* @__PURE__ */ f(o.div, { __css: t.control, ...g(), children: (e.isChecked || e.isIndeterminate) && q({
              isIndeterminate: e.isIndeterminate,
              isChecked: e.isChecked,
              sx: t.icon
            }) })
          ] }),
          l && /* @__PURE__ */ d(
            o.span,
            {
              __css: t.label,
              ...F(),
              "data-invalid": e.isInvalid ? "data-invalid" : void 0,
              children: [
                m,
                " ",
                l,
                " ",
                u
              ]
            }
          )
        ]
      }
    );
  }
);
export {
  J as Checkbox
};
//# sourceMappingURL=Checkbox.es.js.map
